export function isEmailValid(email: string): boolean {

    return new RegExp('^\\S+@\\S+\\.\\S+$').test(email);
}

export function isPhoneValid(email: string): boolean {

    return new RegExp('^[0-9x \\.\\-\\+\\(\\)]+$').test(email);
}
